import type { ThoughtCategory } from "../types";

export const THOUGHT_CATEGORIES: Array<{
  value: ThoughtCategory;
  label: string;
  shortLabel: string;
}> = [
  { value: "business", label: "业务经营", shortLabel: "业务" },
  { value: "brand", label: "品牌与市场", shortLabel: "品牌" },
  { value: "strategy", label: "战略方向", shortLabel: "战略" },
  { value: "team", label: "团队与组织", shortLabel: "团队" },
  { value: "management", label: "管理机制", shortLabel: "管理" },
  { value: "founder", label: "创始人心智", shortLabel: "心智" },
  { value: "other", label: "其他思考", shortLabel: "其他" }
];

export function categoryLabel(category?: ThoughtCategory): string {
  return (
    THOUGHT_CATEGORIES.find((item) => item.value === category)?.label ??
    "未分类"
  );
}

export function categoryClass(category?: ThoughtCategory): string {
  return `category-${category ?? "other"}`;
}
